module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ( _obj = {
      'sidebar': true,
      'show': _vm.show
    }, _obj[_vm.side] = true, _obj )
  }, [_vm._t("header"), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm._t("footer")], 2)
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351b5566","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 109
// module chunks = 0